"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTableAccordionBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_table_base_behavior_1 = require("./bc-table-base-behavior");
var bc_table_constants_1 = require("./bc-table-constants");
var bc_table_constants_2_1 = require("./bc-table-constants-2");
var BcTableAccordionBehavior = (function (_super) {
    __extends(BcTableAccordionBehavior, _super);
    function BcTableAccordionBehavior() {
        var _this = _super.call(this) || this;
        _this.favoriteColumnsIndex = [];
        _this.hasDropdowns = false;
        _this.hasInlineOptions = false;
        _this.customMobileLabel = '';
        _this.hasEmpyAccordion = false;
        setTimeout(function () {
            _this.validateHasEmpyAccordion();
            _this.validateTableHasDropdown();
            _this.setRowLimit();
            _this.executeHideForMobile();
            _this.windoResizeEvent();
            _this.listenSortEvent();
            _this.setActionColumnListener();
            _this.addAriaAccordionTable();
        });
        return _this;
    }
    BcTableAccordionBehavior.prototype.setRowLimit = function () {
        var width = window.innerWidth;
        if (width <= Number(bc_table_constants_1.BcTableConstansts.TABLE_SMALL_BREAK_POINT)) {
            this.limitColumnNumber = Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0);
            this.favoriteColumnsIndex = this.getFavoriteColumns();
            this.addAriaAccordionTable();
        }
        else if (width > Number(bc_table_constants_1.BcTableConstansts.TABLE_SMALL_BREAK_POINT) && width < Number(bc_table_constants_1.BcTableConstansts.TABLE_LARGE_BREAK_POINT)) {
            this.limitColumnNumber = Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_4);
        }
        else if (width >= Number(bc_table_constants_1.BcTableConstansts.TABLE_LARGE_BREAK_POINT) &&
            width < Number(bc_table_constants_1.BcTableConstansts.TABLE_EXTRALARGE_BREAK_POINT)) {
            this.limitColumnNumber = Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_6);
        }
        else {
            this.limitColumnNumber = Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_8);
        }
        if (this.limitColumnNumber !== this.limitColumnNumberBackup) {
            this.limitColumnNumberBackup = this.limitColumnNumber;
            this.structureExtraColumns();
            this.addAriaAccordionTable();
        }
    };
    BcTableAccordionBehavior.prototype.structureExtraColumns = function () {
        if (this.hasEmpyAccordion) {
            this.structureExtraColumnsEmpy();
        }
        else {
            this.removeExtraRows();
            var extraData = window.innerWidth <= Number(bc_table_constants_1.BcTableConstansts.TABLE_SMALL_BREAK_POINT)
                ? this.formatExtraDataForMobile()
                : this.formatExtraData();
            if (Object.keys(extraData[0]).length > 0) {
                for (var i = 1; i < this.rows.length; i++) {
                    var row = this.rows[i];
                    var extraRow = document.createElement('tr');
                    extraRow.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS);
                    var tdElement = document.createElement('td');
                    var extraContent = "<div class=\"bc-table-extra-info-row-content\"></div>";
                    tdElement.innerHTML = extraContent;
                    this.buildListExtraData(tdElement, extraData[i - 1]);
                    extraRow.appendChild(tdElement);
                    this.table.querySelector('tbody').insertBefore(extraRow, row.nextElementSibling);
                }
                this.hiddeUnusedColumns();
                this.removeToogleColumn();
                this.addToggleColumn();
                this.setColspanForExtraRow();
                this.hasDropdowns && this.createOptionBtnByDropdownHtml();
            }
            else {
                this.showColumns();
            }
            this.showActionConlumn();
        }
    };
    BcTableAccordionBehavior.prototype.structureExtraColumnsEmpy = function () {
        window.innerWidth <= Number(bc_table_constants_1.BcTableConstansts.TABLE_SMALL_BREAK_POINT)
            ? this.formatExtraDataForMobile()
            : this.formatExtraData();
        this.formatExtraDataForMobile();
        this.hiddeUnusedColumns();
        this.removeToogleColumn();
        this.addToggleColumn();
        this.setColspanForExtraRow();
    };
    BcTableAccordionBehavior.prototype.removeExtraRows = function () {
        var extraRows = this.table.querySelectorAll("tr[class*=\"bc-table-extra\"]");
        extraRows.forEach(function (row) {
            row.remove();
        });
    };
    BcTableAccordionBehavior.prototype.formatExtraData = function () {
        var extraArrayData = [];
        var rows = __spreadArray([], this.rows, true).splice(1, this.rows.length - 1);
        var starter = this.isSelectionTable ? 1 : 0;
        for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
            var row = rows_1[_i];
            var extraData = {};
            for (var i = this.limitColumnNumber + starter; i <= row.children.length; i++) {
                var cell = row.children[i];
                if (this.columnsData[i - starter] && cell) {
                    extraData[this.columnsData[i - starter].name] = cell.innerHTML;
                }
            }
            extraArrayData.push(extraData);
        }
        return extraArrayData;
    };
    BcTableAccordionBehavior.prototype.formatExtraDataForMobile = function () {
        var _this = this;
        var extraArrayData = [];
        var rows = __spreadArray([], this.rows, true).splice(1, this.rows.length - Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1));
        var starter = this.isSelectionTable ? Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1) : Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0);
        for (var _i = 0, rows_2 = rows; _i < rows_2.length; _i++) {
            var row = rows_2[_i];
            var extraData = {};
            for (var i = starter; i < this.columns.length; i++) {
                var cell = row.children[i];
                if (this.columnsData[i - starter] && !this.favoriteColumnsIndex.includes(i) && cell !== undefined) {
                    extraData[this.columnsData[i - starter].name] = cell.innerHTML;
                }
            }
            extraArrayData.push(extraData);
        }
        setTimeout(function () {
            _this.addFavoriteOrderIndex(_this.rows);
        });
        return extraArrayData;
    };
    BcTableAccordionBehavior.prototype.buildListExtraData = function (el, dataObj) {
        var list = el.querySelector(common_constants_1.BcCommonConstants.DIV_TAG);
        for (var data in dataObj) {
            var item = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            item.className = "bc-table-extra-info-row-content-info bc-row";
            var html = "<div class=\"bc-col-6\">".concat(data, "</div> <div class=\"bc-col-6\">").concat(dataObj[data], "</div>");
            item.innerHTML = html;
            list.appendChild(item);
        }
    };
    BcTableAccordionBehavior.prototype.hiddeUnusedColumns = function () {
        this.showColumns();
        var limit = this.isSelectionTable ? this.limitColumnNumber + 1 : this.limitColumnNumber;
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            for (var i = limit; i < row.children.length; i++) {
                var cell = row.children[i];
                cell.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
            }
            if (!this.selectedRowsElement.includes(row)) {
                row.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_SELECTED_CLASS);
            }
        }
    };
    BcTableAccordionBehavior.prototype.showColumns = function () {
        var start = this.isSelectionTable ? 1 : 0;
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            for (var i = start; i < this.limitColumnNumber + 1; i++) {
                var cell = row.children[i];
                if (cell) {
                    cell.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
                }
            }
        }
        this.showActionConlumn();
    };
    BcTableAccordionBehavior.prototype.removeToogleColumn = function () {
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            var toggle = row.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS));
            if (toggle) {
                toggle.remove();
            }
        }
    };
    BcTableAccordionBehavior.prototype.addToggleColumn = function () {
        var firstCell = document.createElement('th');
        firstCell.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_COLUMN_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS);
        firstCell.setAttribute('id', this.columns[this.columns.length - 1].getAttribute('id') + '_1');
        this.rows[0].appendChild(firstCell);
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var extraCell = document.createElement('td');
            (0, helpers_1.addFocusable)(extraCell, { tabindex: '0' });
            extraCell.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS);
            extraCell.innerHTML = "<em class=\"bc-icon bc-sm\">arrow2-down</em>";
            this.toggleExtraRowEvent(extraCell.querySelector('em'), row);
            row.appendChild(extraCell);
        }
    };
    BcTableAccordionBehavior.prototype.toggleExtraRowEvent = function (button, row) {
        var _this = this;
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.activeToggle(button, row);
        });
    };
    BcTableAccordionBehavior.prototype.activeToggle = function (button, row) {
        var extraRow = row.nextElementSibling;
        if (!extraRow.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS)) {
            extraRow.classList.replace(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS);
            row.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_SELECTED_CLASS);
            button['style'].transform = 'rotate(180deg)';
        }
        else {
            extraRow.classList.replace(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS);
            if (!this.selectedRowsElement.includes(row)) {
                row.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_SELECTED_CLASS);
            }
            button['style'].transform = 'rotate(0deg)';
        }
    };
    BcTableAccordionBehavior.prototype.setColspanForExtraRow = function () {
        var extraRows = this.mySelf.querySelectorAll(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS));
        var colspan = this.getColspanNumber();
        for (var _i = 0, _a = Array.from(extraRows); _i < _a.length; _i++) {
            var row = _a[_i];
            row.firstElementChild.setAttribute('colspan', String(colspan));
        }
    };
    BcTableAccordionBehavior.prototype.getColspanNumber = function () {
        var columns = this.getColums();
        var colspan = 0;
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var column = columns_1[_i];
            if (column.className.indexOf(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS) === -1) {
                colspan++;
            }
        }
        return colspan;
    };
    BcTableAccordionBehavior.prototype.getColums = function () {
        var columns = this.mySelf.querySelectorAll(bc_table_constants_1.BcTableConstansts.TABLE_TH_CLASS);
        return Array.from(columns);
    };
    BcTableAccordionBehavior.prototype.showActionConlumn = function () {
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            var lastCell = row.querySelector("*[class*=\"-action\"]");
            if (lastCell &&
                ((this.columnsData.length <= this.limitColumnNumber &&
                    window.innerWidth >= Number(bc_table_constants_1.BcTableConstansts.TABLE_LARGE_BREAK_POINT)) ||
                    (this.columnsData.length <= this.limitColumnNumber &&
                        window.innerWidth < Number(bc_table_constants_1.BcTableConstansts.TABLE_MEDIUM_BREAK_POINT)))) {
                this.removeExtraRows();
                this.removeToogleColumn();
                lastCell.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
            }
        }
    };
    BcTableAccordionBehavior.prototype.windoResizeEvent = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            _this.setRowLimit();
            _this.executeHideForMobile();
        });
    };
    BcTableAccordionBehavior.prototype.getFavoriteColumns = function () {
        var favoriteColumns = [];
        for (var i = 0; i < this.columns.length; i++) {
            var column = this.columns[i];
            if (column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FAVORITE_COLUMN_CLASS)) {
                favoriteColumns.push(i);
            }
        }
        if (favoriteColumns.length === 0) {
            favoriteColumns = this.setAutoFavorites();
        }
        return favoriteColumns;
    };
    BcTableAccordionBehavior.prototype.setAutoFavorites = function () {
        var favorites = [Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0), Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1), Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_2)];
        if (this.isSelectionTable) {
            favorites = [Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1), Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_2), Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_3)];
        }
        return favorites;
    };
    BcTableAccordionBehavior.prototype.listenSortEvent = function () {
        var _this = this;
        window.addEventListener(bc_table_constants_2_1.BcTableConstansts2.TABLE_SORT_EVENT, function () {
            _this.removeExtraRows();
            _this.structureExtraColumns();
        });
    };
    BcTableAccordionBehavior.prototype.executeHideForMobile = function () {
        if (window.innerWidth <= Number(bc_table_constants_1.BcTableConstansts.TABLE_SMALL_BREAK_POINT)) {
            this.hideColumnsInMobile();
            if (this.customMobileLabel != '') {
                this.createCustomCell();
            }
        }
    };
    BcTableAccordionBehavior.prototype.hideColumnsInMobile = function () {
        this.favoriteColumnsIndex = this.getFavoriteColumns();
        this.validMaxFavoriteColumns();
        var columConditionNumber = Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_3);
        if (this.favoriteColumnsIndex.length > 0 && this.favoriteColumnsIndex.length <= columConditionNumber) {
            for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
                var row = _a[_i];
                for (var i = 0; i < row.children.length; i++) {
                    var cell = row.children[i];
                    this.addRemoveHideForMobile(cell, i);
                }
            }
        }
    };
    BcTableAccordionBehavior.prototype.validMaxFavoriteColumns = function () {
        var columConditionNumber = Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_3);
        if (this.favoriteColumnsIndex.length > columConditionNumber) {
            this.favoriteColumnsIndex = this.favoriteColumnsIndex.splice(0, columConditionNumber);
        }
    };
    BcTableAccordionBehavior.prototype.addRemoveHideForMobile = function (cell, i) {
        if (!this.favoriteColumnsIndex.includes(i)) {
            if (cell.className.indexOf('checkbox') === -1 && cell.className.indexOf('action') === -1) {
                cell.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
            }
        }
        else if (cell.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS)) {
            cell.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
            cell.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_FAVORITE_CELL_CLASS);
        }
    };
    BcTableAccordionBehavior.prototype.addFavoriteOrderIndex = function (rows) {
        for (var _i = 0, rows_3 = rows; _i < rows_3.length; _i++) {
            var row = rows_3[_i];
            var favorites = row.querySelectorAll(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_FAVORITE_CELL_CLASS));
            favorites.forEach(function (fav, index) {
                var newClass = "bc-order-".concat(index + Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1));
                if (!fav.classList.contains(newClass)) {
                    fav.classList.add(newClass);
                }
            });
        }
    };
    BcTableAccordionBehavior.prototype.validateTableHasDropdown = function () {
        if (this.rows[1] && this.rows[1].querySelector('*[class^="bc-dropdown"]') !== null) {
            this.hasDropdowns = true;
        }
        else if (this.rows[1].querySelector('*[class^="bc-table-action-cell-inline"]') !== null) {
            this.hasDropdowns = true;
        }
    };
    BcTableAccordionBehavior.prototype.validateHasEmpyAccordion = function () {
        if (this.table.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_EMPTY_ACCORDION)) {
            this.hasEmpyAccordion = true;
        }
    };
    BcTableAccordionBehavior.prototype.createOptionBtnByDropdownHtml = function () {
        this.getListenersHmtl();
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var extraRow = row.nextElementSibling;
            var options = this.dropdownsOptions[i - 1];
            if (extraRow !== null) {
                var contentContainer = extraRow.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CONTENT_CLASS));
                var optionContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
                optionContainer.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CONTENT_ACTIONS_CLASS);
                for (var _i = 0, _a = Array.from(options); _i < _a.length; _i++) {
                    var option = _a[_i];
                    var button = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
                    button.classList.add(common_constants_1.BcCommonConstants.BTN_TERCIARY_CLASS, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS);
                    var html = "<em class=\"bc-icon bc-sm\">".concat(option.icon, "</em> ").concat(option.text);
                    button.innerHTML = html;
                    this.addEventSigleButton(option, button, i);
                    optionContainer.appendChild(button);
                }
                contentContainer.appendChild(optionContainer);
            }
        }
    };
    BcTableAccordionBehavior.prototype.addEventSigleButton = function (option, button, index) {
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            option.action !== null && option.action({ optionId: option.id, rowIndex: index });
        });
    };
    BcTableAccordionBehavior.prototype.setCustomMobileLabel = function (customMobileLabel) {
        this.customMobileLabel = customMobileLabel;
    };
    BcTableAccordionBehavior.prototype.createCustomCell = function () {
        this.removeCustomCell();
        var rows = this.tbody.getElementsByTagName(common_constants_1.BcCommonConstants.TR_TAG);
        for (var index = 0; index < rows.length; index++) {
            var customCol = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
            customCol.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_FAVORITE_CELL_CLASS, 'bc-order-4', common_constants_1.BcCommonConstants.CUSTOM_CELL);
            customCol.innerHTML = this.customMobileLabel;
            if (!rows[index].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS)) {
                rows[index].appendChild(customCol);
            }
        }
    };
    BcTableAccordionBehavior.prototype.removeCustomCell = function () {
        this.getElements();
        for (var _i = 0, _a = this.cells; _i < _a.length; _i++) {
            var element = _a[_i];
            if (element.classList.contains(common_constants_1.BcCommonConstants.CUSTOM_CELL)) {
                element.remove();
            }
        }
    };
    BcTableAccordionBehavior.prototype.setActionColumnListener = function () {
        var _this = this;
        this.actionCells = Array.from(this.mySelf.querySelectorAll("td[class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS, "\"]")));
        var _loop_1 = function (cell) {
            cell.addEventListener('keydown', function (event) {
                if (event.code == common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || event.key == common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                    if (cell.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS)) {
                        var newCell = cell.childNodes[0];
                        newCell.click();
                    }
                    else if (!_this.isCellActionInline) {
                        var newCell = cell.childNodes[0].childNodes[0];
                        newCell.click();
                    }
                    else {
                        var newCell = cell.childNodes[0];
                        newCell.click();
                    }
                }
            });
        };
        for (var _i = 0, _a = this.actionCells; _i < _a.length; _i++) {
            var cell = _a[_i];
            _loop_1(cell);
        }
    };
    BcTableAccordionBehavior.prototype.addAriaLabelsColumns = function () {
        var currentCols = Array.from(this.table.querySelectorAll('th:not(.bc-hidden):not(.bc-table-checkbox-cell)'));
        for (var index = 0; index < currentCols.length; index++) {
            var newCol = currentCols[index];
            currentCols[index].setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, newCol.innerText +
                ', encabezado de columna, fila 0 de ' + this.rows.length +
                ', columna ' + index + ' de ' + currentCols.length);
            if (currentCols[index].querySelector("em[class*=\"bc-sort-icon-hover\"]")) {
                var hoverIcon = currentCols[index].querySelector("em[class*=\"bc-sort-icon-hover\"]");
                hoverIcon === null || hoverIcon === void 0 ? void 0 : hoverIcon.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'ordenar por ' + newCol.innerText);
                hoverIcon === null || hoverIcon === void 0 ? void 0 : hoverIcon.setAttribute('role', 'button');
            }
        }
    };
    BcTableAccordionBehavior.prototype.addAriaLabelsRows = function () {
        var currentRows = Array.from(this.tbody.querySelectorAll('tr:not(.bc-table-extra-info-row)'));
        for (var index = 0; index < currentRows.length; index++) {
            var newRow = currentRows[index].querySelectorAll('td:not(.bc-hidden):not(.bc-table-checkbox-cell):not(.bc-table-action-cell)');
            for (var j = 0; j < newRow.length; j++) {
                var newCell = newRow[j];
                newCell.setAttribute('aria-label', newCell.innerText + ' fila '
                    + (index + 1) + ' de ' + (currentRows.length + 1) + ', columna ' + (j + 1) + ' de ' + (newRow.length));
            }
        }
    };
    BcTableAccordionBehavior.prototype.addAriaAccordionTable = function () {
        this.addAriaLabelsRows();
        this.addAriaLabelsColumns();
    };
    return BcTableAccordionBehavior;
}(bc_table_base_behavior_1.BcTableBaseBehavior));
exports.BcTableAccordionBehavior = BcTableAccordionBehavior;
